import { Button } from '@infotech-soe/erp-ui-kit';
import React, { JSX, useCallback, useState } from 'react';

import { SignActionArgs } from '../../../services/commands/types';
import { useExternalFormStyles } from '../session/styles';
import { SignForm } from '../sign/SignForm';

import { FormSignatureButtonControlProps } from './FormSignatureButtonControlContainer';

const FormSignatureButtonControl = ({
  allowedDSMediaTypes,
  disabled,
  dsAgents,
  dsKeyTypes,
  forbiddenDSMediaTypes,
  label,
  signAlgo,
  signatureType,
  signData,
  onError,
  onSign,
}: FormSignatureButtonControlProps): JSX.Element => {
  const classes = useExternalFormStyles();

  const [open, setOpen] = useState(false);

  const handleSign = useCallback(
    (args: SignActionArgs) => {
      onSign(args.signatures);
      setOpen(false);
    },
    [onSign]
  );

  return (
    <>
      <Button label={label} disabled={disabled} onClick={() => setOpen(true)} />
      <SignForm
        allowedDSMediaTypes={allowedDSMediaTypes}
        className={classes.form}
        dsAgents={dsAgents}
        dsKeyTypes={dsKeyTypes}
        forbiddenDSMediaTypes={forbiddenDSMediaTypes}
        open={open}
        signAlgo={signAlgo}
        signData={signData}
        signatureType={signatureType}
        onClose={setOpen}
        onError={onError}
        onSign={handleSign}
      />
    </>
  );
};

export default FormSignatureButtonControl;
